import { render, staticRenderFns } from "./FlipbookModal.vue?vue&type=template&id=bec5fe62&scoped=true"
import script from "./FlipbookModal.vue?vue&type=script&lang=js"
export * from "./FlipbookModal.vue?vue&type=script&lang=js"
import style0 from "./FlipbookModal.vue?vue&type=style&index=0&id=bec5fe62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec5fe62",
  null
  
)

export default component.exports